// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
// hooks
import useAuth from './hooks/useAuth';
import { useEffect } from 'react';
// components
import Settings from './components/settings';
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import GoogleAnalytics from './components/GoogleAnalytics';
import NotistackProvider from './components/NotistackProvider';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import FloatingChatButton from './pages/dashboard/ChatModuleSignwise/FloatingChatButton';
// contexts
import RouteChangeCancellation from './components/RouteChangeCancellation';
import { initializeGlobalApiCancellation } from './utils/globalApiCancellationManager';

// ----------------------------------------------------------------------

export default function App() {
  const { isInitialized,isAuthenticated  } = useAuth();
  console.log('isInitialized', isInitialized)
  console.log('isAuthenticated', isAuthenticated)
  const user = localStorage.getItem('user')
  const userData = JSON.parse(user)
  console.log('userData+++++++++++++++', userData)

  // Initialize global API cancellation on app start
  useEffect(() => {
    initializeGlobalApiCancellation();
  }, []);
  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <RtlLayout>
          <NotistackProvider>
            <RouteChangeCancellation />
            <Settings />
            {/* {isAuthenticated ? <FloatingChatButton /> : null } */}
            <ScrollToTop />
            <GoogleAnalytics />
            {isInitialized ? <Router /> : <LoadingScreen />}
          </NotistackProvider>
        </RtlLayout>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
